import React, { useState } from 'react'
import { format } from 'date-fns'
import axios from 'lib/axios'

export default function Summary({ entry, canEdit, canReset, packageHashedId, onReset, dealParties }) {
  if (!entry) return null

  const [resetting, setResetting] = useState(false)

  const handleReset = async () => {
    setResetting(true)
    try {
      await axios.post(`/package_hook/${packageHashedId}/ny_1120b/compliance_form/reset`)
      onReset()
    } finally {
      setResetting(false)
    }
  }

  const addr = entry.address || {}
  const submittedAt = entry.submitted_at ? format(new Date(entry.submitted_at), 'MM/dd/yyyy, hh:mm aaa') : null

  const emailRecipients = [
    { name: entry.full_name, email: entry.email },
    ...(entry.additional_emails || []).filter(Boolean).map(email => ({
      name: dealParties?.find(dp => dp.email === email)?.display_name || null,
      email,
    })),
  ]

  return (
    <div className="compliance-form-summary">
      <div className="dome-d-flex dome-flex-column dome-gap12">
        <div className="compliance-form-summary-row dome-d-flex dome-align-start dome-gap12">
          <div className="compliance-form-summary-address dome-p1 dome-text-w500 dome-flex-1">
            <div className='dome-p3 dome-text-w400'>mailing recipient</div>
            <div>{entry.full_name}</div>
            <div>{addr.line1}{addr.line2 ? `, ${addr.line2}` : ''}</div>
            <div>{addr.city}, {addr.state} {addr.postal_code}</div>
          </div>
          <div className="compliance-form-summary-emails">
            <div className='dome-p3 dome-text-w400'>email(s)</div>
            {emailRecipients.map(({ name, email }, i) => (
              <div key={i}>{name && `${name} - `}<span className='dome-color-aqua'>{email}</span></div>
            ))}
          </div>
        </div>
        {submittedAt && (
          <div className="compliance-form-submitted-line dome-d-flex dome-align-center dome-justify-between">
            <em className="dome-p2 dome-color-med-grey">
              Certified {submittedAt}{entry.submitted_by_name ? ` by ${entry.submitted_by_name}` : ''}. {!canEdit ? 'Cannot edit form until resubmission.' : ''}
            </em>
            {canReset && (
              <button type="button" onClick={handleReset} disabled={resetting} className="dome-btn dome-btn-link dome-btn-link-cancel dome-color-red-alert">
                reset
              </button>
            )}
          </div>
        )}
      </div>

    </div>
  )
}
